import coding from "./img/Coding.png";
import skills from "./img/Team building.png";
import market from "./img/Marketing.png";
import market1 from "./img/Team meeting.png";

const img = [
  {
    id: 1,
    src: coding,
  },
  {
    id: 2,
    src: market,
  },

  {
    id: 3,
    src: skills,
  },

  {
    id: 4,
    src: market1,
  },
];

export default img;
